export default __webpack_public_path__ + "assets/images/a85066b96899e7400704f3f1afb268cc.png";